export type FaqItem = { question: string; answer: string };

/** Single source of truth for the FAQ accordion and the FAQPage JSON-LD. */
export const FAQ_ITEMS: FaqItem[] = [
  {
    question: "How does Logical Health actually work?",
    answer:
      "We send branded, two-way texts from your healthcare organization on the channel each member uses: SMS, RCS, iMessage, or WhatsApp. The AI holds a real conversation, identifies the barrier behind the member's reply, and resolves it: booking visits, explaining benefits, arranging transportation, and handing off to your team when needed.",
  },
  {
    question: "How does Logical Health integrate with existing legacy systems?",
    answer:
      "Logical Health connects to your member data and works alongside your current member-services stack, with no rip-and-replace. We meet your systems where they are, the same way we meet members where they are.",
  },
  {
    question: "What is Neurosymbolic AI and why does it matter?",
    answer:
      "It pairs neural language understanding with symbolic logic developed through Stanford research. That combination produces answers that are instant, accurate, and explainable, so a coverage answer traces back to the rule behind it, instead of being a black-box guess.",
  },
  {
    question: "How does Logical Health ensure accuracy and auditability?",
    answer:
      "Every response is grounded in your healthcare organization's rules and is fully traceable. Other vendors claim their AI is auditable; ours actually is: you can see why it said what it said.",
  },
  {
    question: "Can Logical Health help with Medicare Star ratings?",
    answer:
      "Yes. By closing care gaps, improving member experience, and steering members to the right care at the right time, Logical Health moves the measures that drive HEDIS and Star performance.",
  },
  {
    question: "Does it support languages other than English?",
    answer:
      "Yes. Logical Health holds natural, two-way conversations in a member's preferred language, automatically detecting and responding in-language so members get clear answers without translation friction.",
  },
  {
    question: "Is the Logical Health platform secure?",
    answer:
      "Yes. The platform is HIPAA-compliant, SOC 2 compliant, and built with healthcare-grade safeguards: encryption in transit and at rest, role-based access controls, and full audit logging, so protected health information stays protected at every step.",
  },
  {
    question: "Do members need to download an app to use Logical Health?",
    answer:
      "No. That's the point. Everything happens in the texting app members already have open: no download, no login, no new account.",
  },
];
